import {Inject, Injectable} from "@angular/core";
import {ActionService, ConfigurationService, JwtHttpClientService, ResourceModule} from "@fedelta-pos/data-client";

@Injectable()
export class AppFeedbackService extends ActionService {
    constructor(http: JwtHttpClientService,
                configService: ConfigurationService,
                @Inject(ResourceModule.RESOURCE_NAMESPACE_KEY) nameSpace,
                @Inject(ResourceModule.ACTION_NAMES_KEY) actionNames) {
        console.log("--- AppFeedbackService");

        super(http, configService, nameSpace, actionNames, "app-feedback");
    }
}



// WEBPACK FOOTER //
// ./src/app/customer-info/app-feedback.service.ts